export default __webpack_public_path__ + "static/media/timer.c39f6346.png";